import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponentIdentity implements OnInit {

  constructor(private _dialogRef: MatDialogRef<ConfirmDialogComponentIdentity>,
     @Inject(MAT_DIALOG_DATA) private _data: any, ) { }

     open:boolean;
     isCopied:boolean=false;
     isParent:boolean=false;
     isDelete:boolean=false;
     value:string=";"
  ngOnInit() {
    
    this.open=this._data.open;
    this.isCopied=this._data.isCopied;
    this.isParent=this._data.isParent;
    this.isDelete=this._data.isDelete;
    this.value=this._data.value;

    


    console.log("opennnn",this.open)
  }
  onNoClick(){
    this._dialogRef.close(0);
  }

  Update(){
    this._dialogRef.close(1);
  }

  UpdateYes(){
    this._dialogRef.close(1);
  }
  UpdateNo(){
    this._dialogRef.close(2);
  }


  DeleteYes(){
    this._dialogRef.close(true);
  }
  DeleteNo(){
    this._dialogRef.close(false);
  }
}
